import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthserviceService } from '../services/authservice.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthserviceService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.usuarioValue) {
      // El usuario está autenticado
      return true;
    }
    // Si no está autenticado, redirige al login
    this.router.navigate(['login']);
    return false;
  }
}
